<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button link="/procurement-management/buyers"></back-button>
          Update Buyer
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/procurement-management/buyers`"
              >Buyers</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-10 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Name</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.name"
                  class="form-control"
                  autocomplete="off"
                  placeholder="Name"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Address</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.address"
                  class="form-control"
                  placeholder="Address"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Country</label>
              <div class="col-sm-10">
                <my-select
                  style="margin: 9px !important"
                  disableFormControl="true"
                  :selection.sync="form.country_id"
                  :suggestions="countries"
                  placeholder="Select country"
                ></my-select>
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Email</label>
              <div class="col-sm-10">
                <input
                  type="text"
                  v-model="form.email"
                  class="form-control"
                  placeholder="Email"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Phone</label>
              <div class="col-sm-10">
                <input
                  type="number"
                  v-model="form.phone"
                  class="form-control"
                  placeholder="Phone"
                />
              </div>
            </div>
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">Fax Number</label>
              <div class="col-sm-10">
                <input
                  type="number"
                  v-model="form.fax_no"
                  class="form-control"
                  placeholder="Fax Number"
                />
              </div>
            </div>
            <div class="form mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "BuyerUpdate",
  data() {
    return {
      form: {
        country_id: "",
      },
      countries: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("buyers/masters");
      masters = masters.data;
      masters.countries.forEach((country) => {
        this.countries.push({
          id: country.id,
          name: country.name,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(`/buyers/${this.$route.params.buyerId}`);
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        await axios.patch(`/buyers/${this.$route.params.buyerId}`, this.form);
        this.isLoading = false;
        this.$router.push("/procurement-management/buyers");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
